import { BusinessTypeEnum } from '../data/models/coverage-validator-api-models';
import { LookupViewModel } from '../data/models/ui-models';

export const BUSINESS_TYPES: LookupViewModel[] = [
  { id: BusinessTypeEnum.SoleProprietor, name: 'Sole Proprietor' },
  { id: BusinessTypeEnum.Partnership, name: 'Partnership' },
  { id: BusinessTypeEnum.JointVenture, name: 'Joint Venture' },
  { id: BusinessTypeEnum.Trust, name: 'Trust' },
  { id: BusinessTypeEnum.LimitedLiabilityCompany, name: 'Limited Liability Company' },
  { id: BusinessTypeEnum.Corporation, name: 'Corporation' },
];

export function businessTypeName(type: BusinessTypeEnum | null | undefined): string {
  return BUSINESS_TYPES.find((t) => t.id === type)?.name ?? '';
}
